import gql from 'graphql-tag'

export default gql`query go($name: String, $client_type_id: String, $limit: Int, $offset: Int){
  filter_clients_total(name: $name, client_type_id: $client_type_id)
  filter_clients(name: $name, client_type_id: $client_type_id, limit: $limit, offset: $offset){
    client_id
    name
    client_type{
      description
    }
  }
}
`